var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 59,
    viewBox: "0 0 84 59",
    width: 84,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eb4f92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 43,
    opacity: 0.3,
    rx: 16,
    ry: 16,
    transform: "matrix(-1 0 0 -1 56 86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5,
    cy: 16.5,
    opacity: 0.12,
    rx: 16.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 -1 43 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83 35.2134c.1961 0 .3741-.1146.4552-.2932.0811-.1785.0504-.388-.0787-.5357l-10.5548-12.082v-15.56342c0-.27614-.2239-.5-.5-.5h-7.1434c-.2761 0-.5.22386-.5.5v7.55352l-9.828-9.64938c-.0954-.09361-.2242-.14517-.3578-.14316-.1336.002-.2609.0574-.3533.15383l-28.5 29.71341c-.1387.1446-.1777.358-.0991.5423s.2596.3038.4599.3038h6.6189v22.7866c0 .2761.2238.5.5.5h17.8217 7.1188 17.8217c.2762 0 .5-.2239.5-.5v-22.7866z",
    stroke: "#eb4f92",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.61538 57c-1.95833 0-3.61538198-1.6571-3.6153819-3.6154.00000005-.954.4017109-1.8579 1.0544919-2.5609l9.69121-9.6912c-2.3098-3.2639-3.51493-7.2308-3.51493-11.2479 0-10.9968 8.88783-19.8846 19.88463-19.8846s19.8846 8.8878 19.8846 19.8846-8.8878 19.8846-19.8846 19.8846c-4.0171 0-7.984-1.2051-11.2479-3.5149l-9.69122 9.6912c-.65278.6528-1.60684 1.0545-2.5609 1.0545zm23.50002-14.4615c6.9797 0 12.6538-5.6742 12.6538-12.6539s-5.6741-12.6538-12.6538-12.6538-12.6539 5.6741-12.6539 12.6538 5.6742 12.6539 12.6539 12.6539z",
    fill: "#f5dfe8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ab86b827e76181f5ac0d8f32500f9fc7.svg";
export { ForwardRef as ReactComponent };